import { listSilobagsService } from '@siloreal:shared:api/service/silobag/silobag-list';
import { useSatelliteCertification } from './use-satellite-certification';

export function useHeaderSatelliteCertification() {
  const certification = useSatelliteCertification();

  const generateForAllSilosPro = (): void => {
    void certification.generate(async () => {
      const response = await listSilobagsService({
        filter: { silobag_data_status_id: 2 },
        onlyIds: true,
      });

      return response.ids;
    });
  };

  return {
    ...certification,
    generateForAllSilosPro,
  };
}
